/**
 * <SingleTimePicker />
 *
 * Make a range of time
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes, Component } from 'react';
import classnames from 'classnames'
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import moment from 'moment';
import './TimePicker.scss';

import { TIME_FORMAT } from '../../constants'

const DEFAULT_TIME = moment('10:00', TIME_FORMAT);
const DEFAULT_USE_12HOURS = true;

class SingleTimePicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    dataFormat: PropTypes.string,
  }

  static defaultProps = {
    showSecond: false,
    format: 'h:mm a',
    time: '',
  }

  constructor(props) {
    super(props);
    this.onTimeChange = this.onTimeChange.bind(this);

    this.state = {
      time: DEFAULT_TIME,
    }
  }

  componentWillReceiveProps(nextProps) {
    let {
      time
    } = nextProps;

    if (time) {
      this.setState({
        time,
      });
    }

  }


  onTimeChange(time) {

    let { dataFormat } = this.props;

    this.setState({
      time
    }, ()=>{
      this.props.onChange(this.state.time);
    });
  }

  render() {
    let {
      showSecond,
      format,
      hasValue,
      use12Hours = DEFAULT_USE_12HOURS,
      minuteStep,
      disabled,
    } = this.props;

    let {
      time,
    } = this.state;

    const itDoesHaveValue = this.props.hasValue || (time);

    if(time){
      time = time.lang('en')
    }

    return (
      <div className={classnames('time-picker', 'form-input', { 'has-value': itDoesHaveValue, })}>
        <div className='time-picker-input'>
          <div className='start-time'>
            <TimePicker
              value={time}
              minuteStep={minuteStep}
              onChange={this.onTimeChange}
              format={format}
              use12Hours={use12Hours}
              showSecond={showSecond}
              disabled={disabled || false} />
          </div>
          {/* <div className='reset-button'><i className='fa icon-angle-down'></i></div> */}
        </div>
      </div>
    )
  }
}

export default SingleTimePicker;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/TimePicker/index.js